import React, { useState } from 'react';
import { ArrowLeft, Filter, Flag, ChevronDown, Clock, FileText, Mail, Calendar, CheckCircle, XCircle, RefreshCw, Package, AlertCircle, Plus, Minus, GitBranch, Info, MessageSquare } from 'lucide-react';
export const RunLog = ({
  workflow,
  onClose
}) => {
  const [selectedRun, setSelectedRun] = useState(null);
  const [showExecutionLog, setShowExecutionLog] = useState(false);
  const handleSelectRun = run => {
    setSelectedRun(run === selectedRun ? null : run);
  };
  const handleClickAIAgent = () => {
    setShowExecutionLog(!showExecutionLog);
  };
  // Sample run data
  const runs = [{
    id: 1,
    date: 'Today, 10:42 AM',
    status: 'Ended with issues',
    error: "1 step in this run wasn't completed.",
    user: {
      name: 'Vytautas Svambaris',
      email: 'vytautass@wix.com',
      avatar: null
    },
    version: {
      date: 'Sep 10, 2025, 10:38 AM',
      duration: '30 minutes'
    },
    runId: 'c6cbfc1b-ec86-487a-b171-bcd4c625a401'
  }, {
    id: 2,
    date: 'Today, 10:38 AM',
    status: 'Ended with issues',
    error: null
  }, {
    id: 3,
    date: 'Today, 09:10 AM',
    status: 'Ended',
    error: null
  }, {
    id: 4,
    date: 'Today, 09:01 AM',
    status: 'Ended with issues',
    error: null
  }];
  // Sample test log data for the execution log panel
  const testLogData = [{
    id: 1,
    status: 'success',
    title: 'Searching inventory data',
    description: 'Current inventory information retrieved, providing insights for restock orders.'
  }, {
    id: 2,
    status: 'success',
    title: 'Reading full documentation',
    description: 'Successfully retrieved the method for querying inventory items, including details on filtering, sorting, and pagination.'
  }, {
    id: 3,
    status: 'error',
    title: 'Querying inventory items',
    description: 'Failed to query inventory items due to an incorrect catalog version for the API call.'
  }, {
    id: 4,
    status: 'success',
    title: 'Searching Wix REST documentation',
    description: 'Successfully retrieved documentation on inventory query use cases and API details for Catalog V1.'
  }, {
    id: 5,
    status: 'success',
    title: 'Getting inventory API documentation',
    description: 'The API schema for querying products was successfully retrieved, detailing methods, parameters, and response types.'
  }, {
    id: 6,
    status: 'success',
    title: 'Querying products',
    description: 'Detailed product information and stock data retrieved successfully, including 14 products with their respective prices and availability.'
  }, {
    id: 7,
    status: 'error',
    title: 'Sending email',
    description: 'Attempted to send the comprehensive feedback analysis report, but the action was rejected by the user.'
  }, {
    id: 8,
    status: 'error',
    title: 'Task canceled',
    description: 'Task was stopped manually.',
    feedback: true
  }];
  return <div className="w-full h-screen flex flex-col" data-id="element-1360">
      {/* Header */}
      <div className="border-b border-gray-200 bg-white p-4 flex justify-between items-center" data-id="element-1361">
        <div className="flex items-center" data-id="element-1362">
          <button onClick={onClose} className="mr-4 text-gray-500 hover:text-gray-700" data-id="element-1363">
            <ArrowLeft className="w-5 h-5" data-id="element-1364" />
          </button>
          <button className="mr-4 text-gray-700 font-medium" onClick={onClose} data-id="element-1365">
            Exit
          </button>
          <div className="h-4 border-r border-gray-300 mx-2" data-id="element-1366"></div>
          <div className="flex items-center" data-id="element-1367">
            <span className="px-2 py-1 bg-gray-100 text-gray-700 text-xs font-medium rounded mr-2" data-id="element-1368">
              ACTIVE
            </span>
            <span className="text-gray-700 font-medium" data-id="element-1369">
              {workflow ? workflow.name : 'Feedback Analysis and Summary'}
            </span>
          </div>
        </div>
      </div>
      {/* Main content */}
      <div className="flex flex-1 overflow-hidden" data-id="element-1370">
        {/* Left panel - Run log list */}
        <div className={`w-1/3 ${showExecutionLog ? 'lg:w-1/4' : ''} border-r border-gray-200 bg-white flex flex-col h-full overflow-hidden`} data-id="element-1371">
          <div className="p-4 border-b border-gray-200" data-id="element-1372">
            <div className="flex justify-between items-center mb-4" data-id="element-1373">
              <h2 className="text-xl font-medium text-gray-800" data-id="element-1374">Run log</h2>
              <div className="relative" data-id="element-1375">
                <button className="flex items-center px-3 py-1 border border-gray-200 rounded-md text-sm" data-id="element-1376">
                  <Filter className="w-4 h-4 mr-1 text-gray-500" data-id="element-1377" />
                  Filter
                </button>
              </div>
            </div>
          </div>
          <div className="overflow-auto flex-1" data-id="element-1378">
            <table className="w-full" data-id="element-1379">
              <thead data-id="element-1380">
                <tr className="bg-gray-50 text-left" data-id="element-1381">
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider flex items-center" data-id="element-1382">
                    Start time <ChevronDown className="w-3 h-3 ml-1" data-id="element-1383" />
                  </th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1384">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-1385">
                {runs.map(run => <tr key={run.id} className={`hover:bg-gray-50 cursor-pointer ${selectedRun === run ? 'bg-gray-50' : ''}`} onClick={() => handleSelectRun(run)} data-id="element-1386">
                    <td className="px-6 py-4 text-sm text-gray-800" data-id="element-1387">
                      {run.date}
                    </td>
                    <td className="px-6 py-4 text-sm" data-id="element-1388">
                      <div className="flex items-center" data-id="element-1389">
                        {run.status === 'Ended with issues' ? <Flag className="w-4 h-4 text-red-500 mr-2" data-id="element-1390" /> : run.status === 'Ended' ? <span className="w-4 h-4 bg-blue-500 rounded-full mr-2" data-id="element-1391"></span> : null}
                        <span data-id="element-1392">{run.status}</span>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <div className="p-4 border-t border-gray-200 text-xs text-gray-500" data-id="element-1393">
            Showing runs that ended within the last 30 days. Runs in progress
            are saved for up to a year.
            <span className="text-blue-500 ml-1" data-id="element-1394">Learn more</span>
          </div>
        </div>
        {/* Right panel - Flowchart */}
        <div className={`${showExecutionLog ? 'w-3/4' : 'w-2/3'} bg-gray-50 overflow-auto relative flex`} data-id="element-1395">
          <div className="flex-1 min-h-full p-8 flex items-center justify-center" data-id="element-1396">
            <div className="w-full max-w-md" data-id="element-1397">
              {/* Flowchart */}
              <div className="flex flex-col items-center" data-id="element-1398">
                {/* Trigger node */}
                <div className="mb-2 text-xs text-center text-gray-500 uppercase tracking-wider" data-id="element-1399">
                  Trigger
                </div>
                <div className="w-full bg-white border border-gray-200 rounded-lg p-4 mb-8 relative" data-id="element-1400">
                  <div className="absolute -right-1 -top-1" data-id="element-1401">
                    <CheckCircle className="w-5 h-5 text-blue-500 bg-white rounded-full" data-id="element-1402" />
                  </div>
                  <div className="flex items-center" data-id="element-1403">
                    <div className="w-8 h-8 bg-gray-100 rounded-md flex items-center justify-center mr-3" data-id="element-1404">
                      <FileText className="w-4 h-4 text-gray-600" data-id="element-1405" />
                    </div>
                    <div data-id="element-1406">
                      <div className="text-xs text-gray-500" data-id="element-1407">Wix Forms</div>
                      <div className="text-sm font-medium" data-id="element-1408">Form submitted</div>
                    </div>
                  </div>
                </div>
                {/* Error panel */}
                {selectedRun && selectedRun.error && <div className="w-full mb-8" data-id="element-1409">
                    <div className="bg-red-50 border border-red-100 p-3 rounded-md text-sm text-red-800 mb-4" data-id="element-1410">
                      {selectedRun.error}
                    </div>
                    {selectedRun.user && <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-1411">
                        <div className="flex items-center mb-4" data-id="element-1412">
                          <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center mr-3" data-id="element-1413">
                            <span className="text-xs text-gray-700" data-id="element-1414">VS</span>
                          </div>
                          <div data-id="element-1415">
                            <div className="text-sm font-medium" data-id="element-1416">
                              {selectedRun.user.name}
                            </div>
                            <div className="text-xs text-gray-500" data-id="element-1417">
                              {selectedRun.user.email}
                            </div>
                          </div>
                          <button className="ml-auto text-blue-500 text-sm" data-id="element-1418">
                            View Contact &gt;
                          </button>
                        </div>
                        <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-1419">
                          <div data-id="element-1420">
                            <div className="text-xs text-gray-500 mb-1" data-id="element-1421">
                              Version published
                            </div>
                            <div className="text-sm text-gray-700" data-id="element-1422">
                              {selectedRun.version.date}
                            </div>
                          </div>
                          <div data-id="element-1423">
                            <div className="text-xs text-gray-500 mb-1" data-id="element-1424">
                              Duration
                            </div>
                            <div className="text-sm text-gray-700" data-id="element-1425">
                              {selectedRun.version.duration}
                            </div>
                          </div>
                        </div>
                        <div className="text-xs text-gray-500 mb-1" data-id="element-1426">
                          Run ID:
                        </div>
                        <div className="text-sm text-gray-700 break-all" data-id="element-1427">
                          {selectedRun.runId}
                        </div>
                      </div>}
                  </div>}
                {/* Connector line */}
                <div className="w-px h-12 bg-blue-300" data-id="element-1428"></div>
                {/* Action node */}
                <div className="mb-2 text-xs text-center text-gray-500 uppercase tracking-wider" data-id="element-1429">
                  Action
                </div>
                <div className="w-full bg-white border border-gray-200 rounded-lg p-4 mb-8 relative" data-id="element-1430">
                  <div className="absolute -right-1 -top-1" data-id="element-1431">
                    <CheckCircle className="w-5 h-5 text-blue-500 bg-white rounded-full" data-id="element-1432" />
                  </div>
                  <div className="flex items-center" data-id="element-1433">
                    <div className="w-8 h-8 bg-gray-100 rounded-md flex items-center justify-center mr-3" data-id="element-1434">
                      <Mail className="w-4 h-4 text-gray-600" data-id="element-1435" />
                    </div>
                    <div data-id="element-1436">
                      <div className="text-sm font-medium" data-id="element-1437">Send an email</div>
                    </div>
                  </div>
                </div>
                {/* Connector line */}
                <div className="w-px h-12 bg-blue-300" data-id="element-1438"></div>
                {/* Condition node */}
                <div className="mb-2 text-xs text-center text-gray-500 uppercase tracking-wider" data-id="element-1439">
                  Condition
                </div>
                <div className="w-full bg-white border border-gray-200 rounded-lg p-4 mb-8 relative" data-id="element-1440">
                  <div className="absolute -right-1 -top-1" data-id="element-1441">
                    <CheckCircle className="w-5 h-5 text-blue-500 bg-white rounded-full" data-id="element-1442" />
                  </div>
                  <div data-id="element-1443">
                    <div className="flex items-center mb-2" data-id="element-1444">
                      <div className="w-8 h-8 bg-gray-100 rounded-md flex items-center justify-center mr-3" data-id="element-1445">
                        <GitBranch className="w-4 h-4 text-gray-600" data-id="element-1446" />
                      </div>
                      <div data-id="element-1447">
                        <div className="text-sm font-medium" data-id="element-1448">Check if:</div>
                      </div>
                    </div>
                    <div className="pl-11" data-id="element-1449">
                      <div className="text-sm" data-id="element-1450">
                        <span className="font-medium" data-id="element-1451">
                          Submission date and time
                        </span>{' '}
                        is after
                      </div>
                      <div className="text-sm font-medium" data-id="element-1452">
                        Sep 9, 2025 at 10:37 AM
                      </div>
                    </div>
                  </div>
                </div>
                {/* Split paths */}
                <div className="w-full flex justify-center items-center mb-8" data-id="element-1453">
                  <div className="flex-1 flex flex-col items-center" data-id="element-1454">
                    <div className="text-xs text-gray-500 mb-2" data-id="element-1455">Then</div>
                    <div className="w-px h-12 bg-blue-300" data-id="element-1456"></div>
                  </div>
                  <div className="flex-1 flex flex-col items-center" data-id="element-1457">
                    <div className="text-xs text-gray-500 mb-2" data-id="element-1458">Else</div>
                    <div className="w-px h-12 bg-gray-300" data-id="element-1459"></div>
                  </div>
                </div>
                {/* AI Custom Agent node */}
                <div className="mb-2 text-xs text-center text-gray-500 uppercase tracking-wider" data-id="element-1460">
                  Action
                </div>
                <div className="w-full bg-white border border-red-200 rounded-lg p-4 mb-8 relative cursor-pointer hover:bg-gray-50" onClick={handleClickAIAgent} data-id="element-1461">
                  <div className="absolute -right-1 -top-1" data-id="element-1462">
                    <AlertCircle className="w-5 h-5 text-red-500 bg-white rounded-full" data-id="element-1463" />
                  </div>
                  <div className="flex items-center" data-id="element-1464">
                    <div className="w-8 h-8 bg-teal-100 rounded-md flex items-center justify-center mr-3" data-id="element-1465">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-teal-600" data-id="element-1466">
                        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1467" />
                      </svg>
                    </div>
                    <div data-id="element-1468">
                      <div className="text-xs text-gray-500" data-id="element-1469">
                        AI Custom Agent
                      </div>
                      <div className="text-sm font-medium" data-id="element-1470">
                        Delegate to AI Custom Agent
                      </div>
                    </div>
                  </div>
                </div>
                {/* Connector line */}
                <div className="w-px h-12 bg-blue-300" data-id="element-1471"></div>
                {/* End node */}
                <div className="px-4 py-1 bg-gray-200 text-gray-700 text-xs font-medium rounded" data-id="element-1472">
                  ENDED
                </div>
              </div>
            </div>
          </div>
          {/* Canvas controls */}
          <div className="absolute top-4 right-4 flex flex-col bg-white border border-gray-200 rounded-md shadow-sm" data-id="element-1473">
            <button className="p-2 hover:bg-gray-50 border-b border-gray-200" data-id="element-1474">
              <Plus className="w-4 h-4 text-gray-600" data-id="element-1475" />
            </button>
            <button className="p-2 hover:bg-gray-50 border-b border-gray-200" data-id="element-1476">
              <Minus className="w-4 h-4 text-gray-600" data-id="element-1477" />
            </button>
          </div>
          {/* Execution log panel */}
          {showExecutionLog && <div className="w-[280px] border-l border-gray-200 bg-white flex flex-col h-full overflow-hidden" data-id="element-1478">
              <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center" data-id="element-1479">
                <h2 className="text-lg font-medium text-gray-800" data-id="element-1480">
                  Agent actions
                </h2>
                <button className="text-gray-500 hover:text-gray-700" onClick={() => setShowExecutionLog(false)} data-id="element-1481">
                  <RefreshCw className="w-4 h-4" data-id="element-1482" />
                </button>
              </div>
              <div className="flex-1 overflow-y-auto" data-id="element-1483">
                {testLogData.map(item => <div key={item.id} className="p-4 border-b border-gray-100" data-id="element-1484">
                    <div className="flex items-center justify-between mb-1" data-id="element-1485">
                      <div className="flex items-center" data-id="element-1486">
                        {item.status === 'success' ? <CheckCircle className="w-4 h-4 text-green-500 mr-2" data-id="element-1487" /> : <XCircle className="w-4 h-4 text-red-500 mr-2" data-id="element-1488" />}
                        <span className="text-sm font-medium text-gray-800" data-id="element-1489">
                          {item.title}
                        </span>
                      </div>
                    </div>
                    <p className="text-xs text-gray-600 ml-6" data-id="element-1490">
                      {item.description}
                    </p>
                    {item.feedback && <div className="ml-6 mt-3 bg-blue-50 p-3 rounded-md" data-id="element-1491">
                        <p className="text-sm text-gray-800 mb-2" data-id="element-1492">
                          Not happy with the result?
                        </p>
                        <button className="flex items-center text-sm text-blue-500" data-id="element-1493">
                          <MessageSquare className="w-4 h-4 mr-1" data-id="element-1494" />
                          Give feedback
                        </button>
                      </div>}
                  </div>)}
                <div className="p-4 flex justify-center" data-id="element-1495">
                  <button className="flex items-center text-sm text-blue-500" data-id="element-1496">
                    <RefreshCw className="w-4 h-4 mr-1" data-id="element-1497" />
                    View Details
                  </button>
                </div>
              </div>
            </div>}
        </div>
      </div>
    </div>;
};